export default __webpack_public_path__ + "static/media/regus-kantoor-foto.7596d3c0.webp";